import { createFileRoute } from '@tanstack/react-router'
import TagsForm from 'Administration/components/royalty/tags/TagsForm'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/tags')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <TagsForm />
            </AdministrationPage>
        </Guard>
    ),
})
